var render = function render(){var _vm=this,_c=_vm._self._c;return (Object.keys(_vm.profileData).length)?_c('div',{attrs:{"id":"user-profile"}},[_c('profile-header',{attrs:{"header-data":_vm.profileData}}),_c('section',{attrs:{"id":"profile-info"}},[_c('general-information',{attrs:{"user-uuid":_vm.profileData.uuid}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }